export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const QR_SESSION_REQUEST = "QR_SESSION_REQUEST";
export const QR_SESSION_REQUEST_FAILED = "QR_SESSION_REQUEST_FAILED";
export const QR_SESSION_CHECK = "QR_SESSION_CHECK";
export const QR_SESSION_CHECK_FAIL = "QR_SESSION_CHECK_FAIL";
export const QR_SESSION_LOGIN = "QR_SESSION_LOGIN";
export const QR_SESSION_LOGIN_FAIL = "QR_SESSION_LOGIN_FAIL";
export const GET_LATEST_OPEN_ROOM_ID = "GET_LATEST_OPEN_ROOM_ID";
export const GET_LATEST_OPEN_ROOM_ID_FAILED = "GET_LATEST_OPEN_ROOM_ID_FAILED";

export const ROOM_CREATED = "ROOM_CREATED";
export const ROOM_STATE = "ROOM_STATE";
export const ROOM_ERROR = "ROOM_ERROR";
export const ROOM_LEAVE = "ROOM_LEAVE";
export const ROOM_JOIN = "ROOM_JOIN";
export const ROOM_START_GAME = "ROOM_START_GAME";
export const ROOM_RECONNECT = "ROOM_RECONNECT";
export const ADD_PLAYER = "ADD_PLAYER";
export const REMOVE_PLAYER = "REMOVE_PLAYER";
export const UPDATE_PLAYER = "UPDATE_PLAYER";
export const ADD_AVATAR = "ADD_AVATAR";
export const UPDATE_AVATAR = "UPDATE_AVATAR";

export const UPDATE_CART = "UPDATE_CART";
export const UPDATE_TOASTS = "UPDATE_TOASTS";

export const UPDATE_PRICING = "UPDATE_PRICING";
export const UPDATE_COUNTRY_CODE = "UPDATE_COUNTRY_CODE";

export const SET_DISCOUNT = "SET_DISCOUNT";
export const SET_GAMES = "SET_GAMES";

export const SET_LIMIT_ACCESS_FIRE_TV = "SET_LIMIT_ACCESS_FIRE_TV";
export const SET_APP_TYPE = "SET_APP_TYPE";
export const SET_DEVICE_CAPABILITIES = "SET_DEVICE_CAPABILITIES";
export const SET_IS_APP_VIEW = "SET_IS_APP_VIEW";

// Profile actions
export const SET_USER_PROFILE = "SET_USER_PROFILE";
export const SET_USER_PROFILE_LOADING = "SET_USER_PROFILE_LOADING";
export const SET_USER_VOUCHERS = "SET_USER_VOUCHERS";
export const SET_USER_VOUCHERS_LOADING = "SET_USER_VOUCHERS_LOADING";
export const SET_USER_PURCHASES = "SET_USER_PURCHASES";
export const SET_USER_PURCHASES_LOADING = "SET_USER_PURCHASES_LOADING";
export const UPDATE_USER_EMAIL = "UPDATE_USER_EMAIL";
export const PROFILE_ERROR = "PROFILE_ERROR";

// Impersonation actions
export const IMPERSONATE_LOGIN = "IMPERSONATE_LOGIN";
export const IMPERSONATE_LOGOUT = "IMPERSONATE_LOGOUT";